
// jquery
var $ = require('jquery');

// lightbox2
window.lightbox = require('lightbox2');


$(document).ready(function(){

	// 地図クリック処理
	$('.imgmaplink').on({
		'click': function(){
			postForm($(this).data('action'),$(this).data('name'),$(this).data('value'));
			//location.href = $(this).data('href');
		}
	});

	// 益田地域　チェックボックスの全選択・解除
	$('#masuda').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-masuda').prop('checked', $(this).is(':checked'));
	});

	$('.sub-masuda').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-masuda :checked').length == $('#sub-masuda :input').length){
			$('#masuda').prop('checked', true);
		}else{
			$('#masuda').prop('checked', false);
		}
	});

	// 吉田地域　チェックボックスの全選択・解除
	$('#masuda').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-masuda').prop('checked', $(this).is(':checked'));
	});

	$('.sub-masuda').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-masuda :checked').length == $('#sub-masuda :input').length){
			$('#masuda').prop('checked', true);
		}else{
			$('#masuda').prop('checked', false);
		}
	});

	// 吉田地域　チェックボックスの全選択・解除
	$('#yoshida').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-yoshida').prop('checked', $(this).is(':checked'));
	});

	$('.sub-yoshida').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-yoshida :checked').length == $('#sub-yoshida :input').length){
			$('#yoshida').prop('checked', true);
		}else{
			$('#yoshida').prop('checked', false);
		}
	});

	// 吉田地域　チェックボックスの全選択・解除
	$('#yoshida').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-yoshida').prop('checked', $(this).is(':checked'));
	});

	$('.sub-yoshida').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-yoshida :checked').length == $('#sub-yoshida :input').length){
			$('#yoshida').prop('checked', true);
		}else{
			$('#yoshida').prop('checked', false);
		}
	});

	// 高津地域　チェックボックスの全選択・解除
	$('#takatsu').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-takatsu').prop('checked', $(this).is(':checked'));
	});

	$('.sub-takatsu').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-takatsu :checked').length == $('#sub-takatsu :input').length){
			$('#takatsu').prop('checked', true);
		}else{
			$('#takatsu').prop('checked', false);
		}
	});

	// 益田東部地域　チェックボックスの全選択・解除
	$('#masudatoubu').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-masudatoubu').prop('checked', $(this).is(':checked'));
	});

	$('.sub-masudatoubu').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-masudatoubu :checked').length == $('#sub-masudatoubu :input').length){
			$('#masudatoubu').prop('checked', true);
		}else{
			$('#masudatoubu').prop('checked', false);
		}
	});

	// 益田西部地域　チェックボックスの全選択・解除
	$('#masudaseibu').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-masudaseibu').prop('checked', $(this).is(':checked'));
	});

	$('.sub-masudaseibu').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-masudaseibu :checked').length == $('#sub-masudaseibu :input').length){
			$('#masudaseibu').prop('checked', true);
		}else{
			$('#masudaseibu').prop('checked', false);
		}
	});

	// 匹見地域　チェックボックスの全選択・解除
	$('#hikimi').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-hikimi').prop('checked', $(this).is(':checked'));
	});

	$('.sub-hikimi').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-hikimi :checked').length == $('#sub-hikimi :input').length){
			$('#hikimi').prop('checked', true);
		}else{
			$('#hikimi').prop('checked', false);
		}
	});

	// 益田東部地域　チェックボックスの全選択・解除
	$('#mito').on('change', function() {
		// 「選択肢」のチェック状態を切替える
		$('.sub-mito').prop('checked', $(this).is(':checked'));
	});

	$('.sub-mito').on('change', function() {
		// 「全選択」のチェック状態を切替える
		if ($('#sub-mito :checked').length == $('#sub-mito :input').length){
			$('#mito').prop('checked', true);
		}else{
			$('#mito').prop('checked', false);
		}
	});

});

function postForm(action,name,value) {

	var form = document.createElement('form');
	var request = document.createElement('input');

	form.method = 'POST';
	form.action = action;

	request.type = 'hidden'; //入力フォームが表示されないように
	request.name = name;
	request.value = value;

	form.appendChild(request);
	document.body.appendChild(form);

	form.submit();

}

// ProvidePluginで$に入れているので
// import $ from 'jquery'; の指定は不要
import 'jquery.cookie';

$(function(){

	//ページを読み込んだら、チェックボックスにクッキーの値を反映する
	if($.cookie("color_selected_value")){
				
		var load_values = $.cookie("color_selected_value").split(",");

		for(var i = 0; i < load_values.length; ++i){
			load_values[i] = decodeURIComponent(load_values[i]);
		}
		
		$("input[type=radio][name=btnradio]").each(function(){
			this.checked = $.inArray(this.value, load_values) != -1;
			document.getElementById('page').className = 'site' + ' ' + load_values;
			$("#root").addClass(load_values);
		});
	}
	//拡大縮小
	if($.cookie("scale_selected_value")){
		var load_values = $.cookie("scale_selected_value");
		$("#scale_btn").each(function() {
			$("#scale_btn").addClass('active');
			$("#page").addClass('expansion');
			$('html').css('font-size', '120%');
		});
	}

	//チェックを変えたらクッキーを保存するイベントを登録する
	$("input[type=radio][name=btnradio]").change(function(){

		var save_values = [];
		
		$("input[type=radio][name=btnradio]").each(function(){
			this.checked && save_values.push(encodeURIComponent(this.value));
			document.getElementById('page').className = 'site' + ' ' + save_values;
			$("#root").addClass(save_values);
			if (save_values == "yellow") {
				$("#root").removeClass("white");
				$("#root").removeClass("black");
			} else if (save_values == "black") {
				$("#root").removeClass("white");
				$("#root").removeClass("yellow");
			} else {
				$("#root").removeClass("white");
				$("#root").removeClass("black");
				$("#root").removeClass("yellow");
			}
		});

		$.cookie("color_selected_value", save_values.join(","));
	});

	//拡大縮小
	$("#scale_btn").click(function(){
		var save_values = [];
		if($('#scale_btn').hasClass('active')) {
			save_values.push(encodeURIComponent("active"));
			$("#page").addClass('expansion');
			$('html').css('font-size', '120%');
		} else {
			$("#page").removeClass('expansion');
			$('html').css('font-size', '100%');
		}
		$.cookie("scale_selected_value", save_values);
	});

	//▼現在のcookieの値を見る
	$("#btn_show_cookie").click(function(){
		$("#txt_cookie_value").val($.cookie("scale_selected_value"));
	});

});

